////////////////////////////////////////////////////////////////////////////////
// Custom Properties
////////////////////////////////////////////////////////////////////////////////

 /**
  * Manage Custom Property values
  *
  * @author Mark Notton <mark@marknotton.uk>
  *
  * @link https://github.com/marknotton/custom-properties
  *
  * @license Copyright 2019 Mark Notton
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */

class CustomProperties extends Utilities {

  constructor() {
    super();
    this.extend('customProperty', CustomProperties.set)
  }

  /** ==========================================================================
  * Set Custom Properties
  * ============================================================================
  * @param {String} property CSS property that will be prefixed with a double hyphen.
  * @param {String} value    CSS value for the above property
  * @param {Object} element  DOM element that will be targeted. Defaults to <html> element
  * @param {Object} decorations An associated object where keys are properties and values are values
  *                             so you can add multiple custom properties in one go.
  *
  * @example CustomProperties.set('height', '200px', $('header'))
  * @example $('header').customProperty('height', '200px')
  * @example $('header').customProperty({height: '200px', width : '100px'})
  */
	static set() {

    // FIX: Safari 10 and above always returns false with this check, despite
    // having full support for custom properties.
    let supported = window.CSS && window.CSS.supports && window.CSS.supports('--a', 0)

    // if ( !supported ) {
    if ( false  ) {

      console.warn(`Cannot update the custom properties, because your browser does not support this method.`)

    } else {

      let property, value, group, element = document.documentElement

      Object.values(arguments).forEach((setting) => {

        let type = typeof setting

        if ( type == 'object' ) {
          if ( window.jQuery && setting instanceof jQuery ) {
            element = setting[0]
          } else if ( setting instanceof Node || setting instanceof Element ) {
            element = setting
          } else {
            group = setting
          }
        } else {
          if ( !property ) { property = setting }
          else if ( !value ) { value = setting }
        }

      })

      if ( property && value ) {
        group = { [property] : value }
      }

      if ( typeof group !== 'undefined' ) {
        Object.entries(group).forEach(declaration => {
          let [property, value] = declaration
          element.style.setProperty("--"+property.replace(/^--/g, ''), value)
        })
      } else {
        // console.warn('Customer Property Error:', property, value)

      }

    }
	}

  /** ==========================================================================
  * Remove Custom Properties
  * ============================================================================
  * @param {String} property CSS property that will be prefixed with a double hyphen.
  * @param {String} value    CSS value for the above property
  * @param {Object} element  DOM element that will be targeted. Defaults to <html> element
  * @param {Object} decorations An associated object where keys are properties and values are values
  *                             so you can add multiple custom properties in one go.
  *
  * @example CustomProperties.set('height', '200px', $('header'))
  * @example $('header').customProperty('height', '200px')
  * @example $('header').customProperty({height: '200px', width : '100px'})
  */
  static remove() {

    // FIX: Safari 10 and above always returns false with this check, despite
    // having full support for custom properties.
    let supported = window.CSS && window.CSS.supports && window.CSS.supports('--a', 0)

    // if ( !supported ) {
    if ( false  ) {

      console.warn(`Cannot remove the custom properties, because your browser does not support this method.`)

    } else {

      let property, group, element = document.documentElement

      Object.values(arguments).forEach((setting) => {

        let type = typeof setting

        if ( type == 'object' ) {
          if ( window.jQuery && setting instanceof jQuery ) {
            element = setting[0]
          } else if ( setting instanceof Node || setting instanceof Element ) {
            element = setting
          }
        } else {
          if ( !property ) { property = setting }
        }

      })

      element.style.setProperty("--"+property.replace(/^--/g, ''), '')

    }
  }
}
